import { v4 as uuidv4 } from 'uuid'

export default {
  mounted: (el, binding) => {
    const key = uuidv4()
    const content = binding?.value?.content ?? binding.value ?? false

    if (!content) return

    // caller el
    el.style.setProperty('anchor-name', `--${key}`)
    el.dataset.popoverId = key

    // popover el
    const tooltipEl = document.createElement('div')
    tooltipEl.innerHTML = content
    tooltipEl.classList.add('dvp-tooltip')
    tooltipEl.setAttribute('id', `tooltip-${key}`)
    tooltipEl.setAttribute('popover', 'hint')
    tooltipEl.style.setProperty('position-anchor', `--${key}`)

    el.parentNode.insertBefore(tooltipEl, el)

    // events
    if (binding.value.trigger === 'click') {
      tooltipEl.addEventListener('toggle', event => {
        el.dataset.popoverStatus = (event.newState === 'open')
      })

      el.addEventListener('click', () => {
        if (el.dataset.popoverStatus === 'true') {
          tooltipEl.hidePopover()
        } else {
          tooltipEl.showPopover()
        }
      })
    } else {
      el.addEventListener('mouseenter', () => {
        tooltipEl.showPopover()
      })

      el.addEventListener('mousedown', () => {
        if (!tooltipEl.matches(':popover-open')) {
          tooltipEl.showPopover()
        }
      })

      el.addEventListener('mouseleave', () => {
        tooltipEl.hidePopover()
      })
    }
  },
  updated: (el, binding) => {
    const content = binding?.value?.content ?? binding.value ?? false
    if (!content) return
      
    document.getElementById(`tooltip-${el.dataset.popoverId}`).innerHTML = content
  }
}